import { createContext } from 'react';

/** @type {import('react').Context<import('./Config').Config>} */
export const ConfigContext = createContext({});
